module.exports = __webpack_public_path__ + "img/LATAM_LOW_GLYCEMIC.abf48d0a.png";